import type { MACCountryISOAction, MACCountryISOState } from '../models';
import { COUNTRY_BY_NAME } from '../actions/country';

export const initialState = {
  countriesByName: {},
};

export default (
  state: MACCountryISOState = initialState,
  action: MACCountryISOAction,
): MACCountryISOState => {
  if (action.type === COUNTRY_BY_NAME) {
    return {
      ...state,
      countriesByName: {
        ...state.countriesByName,
        [action.countryName.toLowerCase()]: action.progress,
      },
    };
  }

  return state;
};
